import {
  createRegimenBuilderFlowSchema,
  createSkinAnalyzerFlowSchema,
  type FlowSchema,
} from './flow-schema.js';

export const STOREFRONT_LEAD_MAGNET_SLUGS = ['regimenbuilder', 'skin-analyzer'] as const;

/** Storefront lead flows that call `GET /catalog/routine-match` — need `routine:*` products before publish. */
export const ROUTINE_MATCH_LEAD_FLOW_SLUGS = STOREFRONT_LEAD_MAGNET_SLUGS;

export type RoutineMatchLeadFlowSlug = (typeof ROUTINE_MATCH_LEAD_FLOW_SLUGS)[number];

export function leadFlowRequiresRoutineProductTags(slug: string): slug is RoutineMatchLeadFlowSlug {
  return (ROUTINE_MATCH_LEAD_FLOW_SLUGS as readonly string[]).includes(slug);
}

export type StorefrontLeadMagnetSlug = (typeof STOREFRONT_LEAD_MAGNET_SLUGS)[number];

export type StorefrontLeadMagnetDefinition = {
  slug: StorefrontLeadMagnetSlug;
  defaultName: string;
  label: string;
  description: string;
  storefrontPath: string;
  createSchema: () => FlowSchema;
};

export const STOREFRONT_LEAD_MAGNETS: StorefrontLeadMagnetDefinition[] = [
  {
    slug: 'regimenbuilder',
    defaultName: 'Routine Builder',
    label: 'Routine sur mesure',
    description: 'Bouton header « Ma routine » → /flows/regimenbuilder',
    storefrontPath: '/flows/regimenbuilder',
    createSchema: createRegimenBuilderFlowSchema,
  },
  {
    slug: 'skin-analyzer',
    defaultName: 'Analyse peau IA',
    label: 'Analyse peau par caméra',
    description: 'Bloc accueil analyse peau → /flows/skin-analyzer',
    storefrontPath: '/flows/skin-analyzer',
    createSchema: createSkinAnalyzerFlowSchema,
  },
];

export function isStorefrontLeadMagnetSlug(slug: string): slug is StorefrontLeadMagnetSlug {
  return (STOREFRONT_LEAD_MAGNET_SLUGS as readonly string[]).includes(slug);
}

export type StorefrontLeadMagnetStatusItem = {
  slug: StorefrontLeadMagnetSlug;
  label: string;
  storefrontPath: string;
  exists: boolean;
  published: boolean;
  ready: boolean;
  flowId: string | null;
  flowName: string | null;
  status: 'missing' | 'draft' | 'ready' | 'blocked';
  /** Set when regimen builder cannot run (no `routine:*` products on storefront). */
  blockReason?: string | null;
  routineTaggedProductCount?: number;
};

export type StorefrontLeadMagnetsStatus = Record<
  StorefrontLeadMagnetSlug,
  StorefrontLeadMagnetStatusItem
>;
